/**
 * Component: ChatConversation
 * Displays chat messages with RAG source indicators
 */

import React, { useEffect } from 'react';
import { useTranslation } from '../context/TranslationContext';

export default function ChatConversation({ messages, onSourceClick }) {
  const { t, loadPageTranslations } = useTranslation();

  useEffect(() => {
    loadPageTranslations('CHATBOT');
  }, [loadPageTranslations]);

  // Debug: log messages when they change
  useEffect(() => {
    if (messages.length > 0) {
      const lastMsg = messages[messages.length - 1];
      console.log('[ChatConversation] Last message:', {
        role: lastMsg.role,
        message_id: lastMsg.message_id,
        rag_sources_count: lastMsg.rag_sources?.length || 0,
        rag_sources: lastMsg.rag_sources,
      });
    }
  }, [messages]);

  if (messages.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-gray-500">{t('CHATBOT', 'NO_MESSAGES', 'No messages yet')}</p>
        <p className="text-sm text-gray-400 mt-2">{t('CHATBOT', 'START_CONVERSATION', 'Start a conversation with the AI assistant')}</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {messages.map((msg) => (
        <div
          key={msg.message_id}
          className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
        >
          <div
            className={`max-w-md lg:max-w-xl rounded-lg px-4 py-3 ${
              msg.role === 'user'
                ? 'bg-blue-600 text-white rounded-br-none'
                : 'bg-gray-200 text-gray-900 rounded-bl-none'
            }`}
          >
            <p className="text-sm whitespace-pre-wrap break-words">{msg.content}</p>

            {/* RAG Sources Indicator */}
            {msg.rag_sources && msg.rag_sources.length > 0 && (
              <div className="mt-3 pt-2">
                <button
                  onClick={() => onSourceClick(msg.rag_sources)}
                  className="inline-flex items-center gap-1 px-2 py-1 bg-blue-100 text-blue-700 rounded-md text-xs hover:bg-blue-200 hover:text-blue-900 transition-colors cursor-pointer border border-blue-300"
                >
                  📚 {t('CHATBOT', 'SOURCES', 'Sources ({{count}})', { count: msg.rag_sources.length })}
                </button>
              </div>
            )}

            <p className="text-xs mt-1 opacity-70">
              {new Date(msg.created_at).toLocaleTimeString()}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
